import React, { useMemo } from 'react';
import { useLotsCommerciaux } from '../../../contexts/lotCommercialContext';
import { useStades } from '../../../contexts/stadeContext';

const TableAppelsDeFonds = () => {

    const { lotCommercialActif } = useLotsCommerciaux();
    const { prixTTC } = lotCommercialActif || {};
    const { stades } = useStades();

    const currencyFormat = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });
    const percentFormat = new Intl.NumberFormat("fr-FR", { style: "percent", maximumFractionDigits: 2 });

    const styles = useMemo(
        () => {
            const cell = { minWidth: 240, maxWidth: 240 };
            const cellSm = { minWidth: 120, maxWidth: 120 };

            let styles = {
                body: {
                    borderBottom: "2px solid #D9D9D9",
                    borderTop: "2px solid #D9D9D9"
                },
                cell,
                cellCenter: { ...cell, textAlign: "center" },
                cellRight: { ...cell, textAlign: "right" },
                cellSm,
                cellSmCenter: { ...cellSm, textAlign: "center" },
                cellSmRight: { ...cellSm, textAlign: "right" },
                header: {
                    background: "white",
                    color: "red",
                    fontSize: 12,
                    height: 50,
                    lineHeight: "14px",
                    textAlign: "left",
                    textTransform: "uppercase",
                    verticalAlign: "bottom"
                },
                row: {
                    color: "#8A8A8A",
                    fontSize: 16,
                    fontWeight: 400,
                    height: 50,
                    lineHeight: "19px"
                },
                outer: { display: "grid" },
                table: {
                    borderCollapse: "collapse",
                    display: "block",
                    marginRight: 1,
                    overflowX: "auto"
                }
            };

            return styles;
        },
        []
    );

    return <div style={styles.outer}>
        <table style={styles.table}>
            <thead style={styles.header}>
                <tr>
                    <th style={{ ...styles.cell, paddingBottom: 10 }}>nom du stade</th>
                    <th style={{ ...styles.cellSmCenter, paddingBottom: 10 }}>date prévisionnelle</th>
                    <th style={{ ...styles.cellSmCenter, paddingBottom: 10 }}>date réelle</th>
                    <th style={{ ...styles.cellSmCenter, paddingBottom: 10 }}>pourcentage</th>
                    <th style={{ ...styles.cellSmRight, paddingBottom: 10 }}>montant ttc</th>
                </tr>
            </thead>
            <tbody style={styles.body}>
                {Array.isArray(stades) && stades.map((stade, index) => {
                    const { datePrevisionnelleClient, dateADF, montantTTCExigible, nomStade, pourcentageAvancementTravaux, pourcentageCumul } = stade;

                    let montant = 0;
                    if (!!montantTTCExigible) montant = montantTTCExigible;
                    else montant = prixTTC * pourcentageAvancementTravaux;

                    let trStyle = { ...styles.row };
                    if (index % 2 === 1) trStyle.background = "#F6F6F6";
                    else trStyle.background = "white";

                    return <tr key={index} style={trStyle}>
                        <td style={styles.cell}>{nomStade}</td>
                        <td style={styles.cellSmCenter}>{!!datePrevisionnelleClient && new Date(datePrevisionnelleClient).toLocaleDateString("fr-FR")}</td>
                        <td style={styles.cellSmCenter}>{!!dateADF && new Date(dateADF).toLocaleDateString("fr-FR")}</td>
                        <td style={styles.cellSmCenter}>{percentFormat.format(pourcentageCumul)}</td>
                        <td style={styles.cellSmRight}>{currencyFormat.format(montant)}</td>
                    </tr>;
                })}
            </tbody>
        </table>
    </div>;

};

export default TableAppelsDeFonds;